import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneReturn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#airplane-return_svg__a)">
      <path
        fill="#000"
        fillRule="evenodd"
        d="M12.917 4.023a.65.65 0 0 1 .281.054.66.66 0 0 1 .366.53l.61 7.375a1 1 0 0 0 .573.824l3.772 1.76a1.068 1.068 0 0 1 .517 1.427l-.003.006a1.068 1.068 0 0 1-1.427.516l-12.53-5.837.397-3.434a.73.73 0 0 1 1.025-.582.78.78 0 0 1 .38.433l.762 2.097a1 1 0 0 0 .516.564l1.88.88a1 1 0 0 0 1.412-.749l.849-5.325a.65.65 0 0 1 .62-.54Zm1.117-1.763.016.007a2.66 2.66 0 0 1 1.506 2.163v.008l.563 6.801 3.243 1.514a3.071 3.071 0 0 1 1.484 4.09 3.071 3.071 0 0 1-4.09 1.483l-.003-.002-13.175-6.138a1 1 0 0 1-.571-1.02l.48-4.15a2.73 2.73 0 0 1 3.866-2.162l.02.01A2.78 2.78 0 0 1 8.76 6.42l.617 1.699.304.141.642-4.026a2.65 2.65 0 0 1 3.71-1.975ZM3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="airplane-return_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAirplaneReturn;
